<template>
  <div class="container">
    <div class="navi">
        <a @click="goback()">
          <span class="icon-arrow-left"></span>
        </a>
    </div>
    <div class="title">联系我们</div>

    <div class="weui-msg">
        <div class="weui-msg__icon-area"><img class="phonechat" src="../../assets/img/global/empty.svg"></div>
        <div class="weui-msg__text-area">
            <p class="weui-msg__desc">亲爱的用户，欢迎使用到家！<br>有任何疑问，请随时通过微信或电话联系我们！</p>
        </div>
        <div class="weui-msg__opr-area btn-padding">
            <p class="weui-btn-area">
                <div class="weui-btn weui-btn_primary color-wechat"><span class="icon-wechat"></span> 微信在线客服</div>
                <a href="tel:0477747777" class="weui-btn weui-btn_default"><span class="icon-phone"></span> 电话联系客服</a>
            </p>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'contact',
  data () {
    return {
      order:{}
    }
  },
  methods: {
    doCopy: function () {
      this.$copyText("daojia4").then(function (e) {
        console.log(e)
      }, function (e) {
        console.log(e)
      })
    },
    goback: function() {
      this.$router.go(-1);
    }
  },
  components: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container /deep/ .weui-msg{
  padding-top:0;
}

.weui-msg__opr-area{
  padding:0 2em;
}

.phonechat{
  width:60%;
}
</style>



// WEBPACK FOOTER //
// src/pages/other/contact-wechat.vue